import { Constants } from "./launch-constants";

function getBasePath() {
    return process.env.PUBLIC_URL + "/";
}

function getRoutePath(route) {
    const basePath = getBasePath();
    return `${basePath}${route}`;
}

function isSuccessResult(resultType) {
    return [
        Constants.ResultTypes.File,
        Constants.ResultTypes.ProtocolHandler,
        Constants.ResultTypes.Browser,
    ].includes(resultType?.toLowerCase());
}

function isBrowserLaunch(protocol) {
    return [
        Constants.Protocols.CitrixBrowser,
        Constants.Protocols.ParallelsBrowser,
        Constants.Protocols.DcvBrowser,
    ].includes(protocol.toLowerCase());
}

function getLaunchType(response) {
    return response?.headers?.get(Constants.Headers.ResultType)?.toLowerCase();
}

function getMimeType(response) {
    const contentType = response.headers.get(Constants.Headers.MimeType) || "";

    // Content-Type can contain other values in array (e.g. encoding)
    // Only assurance is that mime type is first
    return contentType.split(";")[0].trim().toLowerCase();
}

function getProtocol(response) {
    return response.headers.get(Constants.Headers.ProtocolType)?.toLowerCase();
}

function getDownloadFileName(response) {
    return response.headers.get(Constants.Headers.DownloadName);
}

function protocolEquals(val1, val2) {
    return val1?.toLowerCase() === val2;
}

function doesRelativeUrlEqual(url, route) {
    const routePath = getRoutePath(route);
    return url.pathname.toUpperCase() === routePath.toUpperCase();
}

function buildProgressText(resultType, response) {
    switch (resultType) {
        case Constants.ResultTypes.File:
            const fileName = getDownloadFileName(response);
            return Constants.ProgressText.getFileProgressText(fileName);
        case Constants.ResultTypes.ProtocolHandler:
            const protocol = getProtocol(response);
            switch (protocol) {
                case Constants.Protocols.ParallelsClient:
                    return Constants.ProgressText.ParallelsClient;

                case Constants.Protocols.DcvClientHandler:
                    return Constants.ProgressText.DcvClientHandler;

                default:
                    throw new Error(`Unknown protocol handler: ${protocol}`);
            }

        case Constants.ResultTypes.Browser:
            return Constants.ProgressText.Browser;

        default:
    }
}

export const Helpers = {
    getBasePath,
    getRoutePath,
    isSuccessResult,
    isBrowserLaunch,
    getLaunchType,
    getMimeType,
    getProtocol,
    getDownloadFileName,
    protocolEquals,
    doesRelativeUrlEqual,
    buildProgressText,
};
